import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { BrandedPanel } from 'web-ui-components/lib/layout/content';
import { Inline } from 'web-ui-components/lib/layout/grids';
import { StandardBody } from 'web-ui-components/lib/typography/body';
import { StandardLabel } from 'web-ui-components/lib/typography/labels';
import { StatusTag } from 'web-ui-components/lib/typography/tags';
import withContent from '../../../containers/withContent';
import { getCloseMatchFields } from '../../states/selectors';
import copContent, { contentPropTypes } from '../Content/cop.content';

function CloseMatchDetails({ closeMatchFields, content }) {
	const { accountType, matchedAccountType, accountName, matchedAccountName } = closeMatchFields;
	const { nameEnteredLabel, nameMatchedLable, accountEnteredLabel, accountMatchedLabel } = content;
	return (
		<div>
			<BrandedPanel>
				{accountType && (
					<div>
						<StandardLabel>
							<span>{accountEnteredLabel}</span>
						</StandardLabel>
						<Inline.Justified
							nodes={[
								<StandardBody>
									<span>{accountType}</span>
								</StandardBody>,
								<StatusTag.WarningMajor>Close match</StatusTag.WarningMajor>,
							]}
						/>
					</div>
				)}
				{accountName && (
					<div>
						<StandardLabel>
							<span>{nameEnteredLabel}</span>
						</StandardLabel>
						<Inline.Justified
							nodes={[
								<StandardBody>
									<span>{accountName}</span>
								</StandardBody>,
								!accountType && <StatusTag.WarningMajor>Close match</StatusTag.WarningMajor>,
							]}
						/>
					</div>
				)}
			</BrandedPanel>

			<BrandedPanel>
				{matchedAccountType && (
					<div>
						<StandardLabel>
							<span>{accountMatchedLabel}</span>
						</StandardLabel>
						<Inline.Justified
							nodes={[
								<StandardBody>
									<span>{matchedAccountType}</span>
								</StandardBody>,
								<StatusTag.Success>Match</StatusTag.Success>,
							]}
						/>
					</div>
				)}
				{matchedAccountName && (
					<div>
						<StandardLabel>
							<span>{nameMatchedLable}</span>
						</StandardLabel>
						<Inline.Justified
							nodes={[
								<StandardBody>
									<span>{matchedAccountName}</span>
								</StandardBody>,
								!accountType && <StatusTag.Success>Match</StatusTag.Success>,
							]}
						/>
					</div>
				)}
			</BrandedPanel>
		</div>
	);
}

CloseMatchDetails.propTypes = {
	copyText: PropTypes.shape({}),
	closeMatchFields: PropTypes.shape({}),
	content: PropTypes.shape(contentPropTypes),
};

const mapStateToProps = (state) => ({
	closeMatchFields: getCloseMatchFields(state),
});

const connectWrapper = connect(mapStateToProps);
const contentWrapper = withContent({ content: copContent });

export default compose(connectWrapper, contentWrapper)(CloseMatchDetails);
